import { NormalizedNumber } from '@sparkdotfi/common-universal'
import BigNumber from 'bignumber.js'

import { PositionOverview } from './types'

export interface MakeUpdatedPositionOverviewParams {
  healthFactor: BigNumber | undefined
  leftoverDebt: NormalizedNumber
}
export function makeUpdatedPositionOverview({
  healthFactor,
  leftoverDebt,
}: MakeUpdatedPositionOverviewParams): PositionOverview {
  return {
    // @todo: change 1e-8 when repaying max is handled properly
    healthFactor: !healthFactor && leftoverDebt.lt(1e-8) ? new BigNumber(Number.POSITIVE_INFINITY) : healthFactor,
    debt: leftoverDebt,
  }
}
